import React, { useCallback } from 'react'

interface MiddleEllipsisProps extends React.AllHTMLAttributes<HTMLElement> {}

const MiddleEllipsis = ({ ...props }: MiddleEllipsisProps) => {
  const prepEllipse = (node: HTMLElement) => {
    const parent = node.parentElement
    const child = node.childNodes[0] as HTMLElement
    const txtToEllipse = child

    if (parent && child && txtToEllipse) {
      // (Re)-set text back to data-original-text if it exists.
      if (txtToEllipse.hasAttribute('data-original')) {
        txtToEllipse.textContent = txtToEllipse.getAttribute('data-original')
      }

      ellipse(
        // Use the smaller width.
        node.offsetWidth > parent.offsetWidth ? parent : node,
        child,
        txtToEllipse,
      )
    }
  }
  const measuredParent = useCallback(
    (node: HTMLDivElement) => {
      if (node !== null) {
        window.addEventListener('resize', () => {
          prepEllipse(node)
        })
        prepEllipse(node)
      }
    },
    [props.width, props.children],
  )

  return (
    <div
      ref={measuredParent}
      style={{
        wordBreak: 'keep-all',
        overflowWrap: 'normal',
        ...(props.width && { width: props.width }),
      }}
    >
      {props.children}
    </div>
  )
}

const ellipse = (
  parentNode: HTMLElement,
  childNode: HTMLElement,
  txtNode: HTMLElement,
) => {
  const childWidth = childNode.offsetWidth
  const containerWidth = parentNode.offsetWidth
  const txtWidth = txtNode.offsetWidth
  const targetWidth = childWidth > txtWidth ? childWidth : txtWidth

  if (targetWidth > containerWidth) {
    if (!txtNode.textContent) {
      return
    }
    const str = txtNode.textContent
    const txtChars = str.length
    const avgLetterSize = txtWidth / txtChars
    const canFit = (containerWidth - (targetWidth - txtWidth)) / avgLetterSize
    const delEachSide = (txtChars - canFit + 5) / 2
    const endLeft = Math.floor(txtChars / 2 - delEachSide)
    const startRight = Math.ceil(txtChars / 2 + delEachSide)

    txtNode.setAttribute('data-original', txtNode.textContent)
    txtNode.textContent =
      str.substring(0, endLeft) + '...' + str.substring(startRight)
  }
}

export default MiddleEllipsis
